var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "article_svg__a",
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "article_svg__c",
    d: "M0 70h70V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.357 .15)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "article_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#article_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63 59.5c0 2.1-1.4 3.5-3.5 3.5H20.3c.35-1.05.7-2.1.7-3.5V7h42v52.5zM14 0v59.5c0 2.1-1.4 3.5-3.5 3.5S7 61.6 7 59.5v-28H0v28C0 65.45 4.55 70 10.5 70h49C65.45 70 70 65.45 70 59.5V0H14z",
    fill: "#000",
    mask: "url(#article_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "article_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#article_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#article_svg__d)",
    d: "M28 28h28v-7H28zM28 42h28v-7H28zM28 56h28v-7H28z"
  }))));
}
export default __webpack_public_path__ + "a718c11d95089bdff16e184f5b0e4461.svg";
export { SvgArticle as ReactComponent };